function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -2.538)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 2.538)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.658,5.725h-.637V4.45a1.914,1.914,0,0,0-1.912-1.912H1.912A1.914,1.914,0,0,0,0,4.45V16a1.914,1.914,0,0,0,1.912,1.912H3.187v.637A1.914,1.914,0,0,0,5.1,20.46h9.56a1.914,1.914,0,0,0,1.912-1.912V7.636A1.914,1.914,0,0,0,14.658,5.725ZM1.912,16.636A.638.638,0,0,1,1.275,16V4.45a.638.638,0,0,1,.637-.637h10.2a.638.638,0,0,1,.637.637V16a.638.638,0,0,1-.637.637ZM15.3,18.548a.638.638,0,0,1-.637.637H5.1a.638.638,0,0,1-.637-.637v-.637h7.648A1.914,1.914,0,0,0,14.021,16V7h.637a.638.638,0,0,1,.637.637Z",
  transform: "translate(0 -2.538)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.187 9.626)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M105.472,147.692H99.1a.637.637,0,1,0,0,1.275h6.373a.637.637,0,1,0,0-1.275Z",
  transform: "translate(-98.462 -147.692)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.187 6.483)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M105.472,147.692H99.1a.637.637,0,1,0,0,1.275h6.373a.637.637,0,1,0,0-1.275Z",
  transform: "translate(-98.462 -147.692)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.461 12.812)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M142.307,246.154h-3.824a.637.637,0,1,0,0,1.275h3.824a.637.637,0,0,0,0-1.275Z",
  transform: "translate(-137.846 -246.154)"
})));

var SvgRelatorio = function SvgRelatorio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.57,
    height: 17.922,
    viewBox: "0 0 16.57 17.922",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRelatorio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/relatorio.fd20c5e4.svg";
export { ForwardRef as ReactComponent };